import { useTranslation } from "react-i18next";

import { UHFMeasurement } from "../../shared/interfaces/Result";
import { MeasurementType } from "../../shared/enums/Result";

import { Card } from "../../shared/Card";
import { FormRow } from "../../shared/FormLayout/FormRow";

interface UHFMeasurementCardProps {
  measurement: UHFMeasurement;
}

export function UHFMeasurementCard(props: UHFMeasurementCardProps) {
  const { t } = useTranslation();

  return (
    <Card
      title={t("results.measurementType", {
        measurementType: `$t(MeasurementTypes.${MeasurementType.UHF} )`,
      })}
      className="mb-3"
    >
      <FormRow label={t("measurements.MeasureDBM")} value={props.measurement.MeasureDBM} />
      <FormRow label={t("measurements.Gain")} value={props.measurement.Gain} />
      <FormRow label={t("measurements.Frequency")} value={props.measurement.Frequency} />
      <FormRow label={t("measurements.Baseline")} value={props.measurement.Baseline} />
      <FormRow
        label={t("measurements.WidebandMode")}
        value={props.measurement.WidebandMode ? t("common.true") : t("common.false")}
      />
      <FormRow
        label={t("measurements.PhaseReferenceLock")}
        value={props.measurement.PhaseReferenceLock ? t("common.true") : t("common.false")}
      />
      <FormRow
        label={t("measurements.PhaseReferenceType")}
        value={props.measurement.PhaseReferenceType && t(`PhaseReferenceType.${props.measurement.PhaseReferenceType}`)}
      />
    </Card>
  );
}
